import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mxnCurrency',
})
export class MxnCurrencyPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
      return '';
    }

    const isInteger = Math.abs(numericValue - Math.trunc(numericValue)) < Number.EPSILON;
    const fractionDigits = isInteger ? 0 : 2;

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'MXN',
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(numericValue);
  }
}
